import * as React from "react";
import { UitkExpandoCard, UitkExpandoCardTypeSize } from "uitk-react-expando";
import { UitkText } from "uitk-react-text";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { decorateEditorialHtml } from "../../../../ContentUtilities";
import { ContentProps } from "../../../../typings";

export const CitifaqSection = (props: ContentProps) => {
  const flexComponent = props.flexComponent;
  const model = flexComponent && flexComponent.model;
  const items = (model.items && model.items.filter((item) => item)) || [];
  const [isVisible, setIsVisible] = React.useState(false);
  const toggle = React.useCallback(() => setIsVisible(!isVisible), [isVisible]);

  if (items.length !== 2) {
    return null;
  }

  return (
    <UitkLayoutFlex space="two" wrap="wrap" justifyContent="center">
      <UitkLayoutFlexItem grow={1} minWidth="twenty_four" maxWidth="one_hundred_twenty">
        <div className="all-b-padding-three">
          <UitkExpandoCard
            isVisible={isVisible}
            handleClick={toggle}
            expandoTitle={
              <div className="all-r-margin-twelve" dangerouslySetInnerHTML={decorateEditorialHtml(items[0].text)} />
            }
            expandoDescription={
              <UitkText size={200}>
                <div dangerouslySetInnerHTML={decorateEditorialHtml(items[1].text)} />
              </UitkText>
            }
            expandoTitleSize={UitkExpandoCardTypeSize.TYPE_400}
          />
        </div>
      </UitkLayoutFlexItem>
    </UitkLayoutFlex>
  );
};

export default CitifaqSection;
